import React from 'react';
import { Typography } from 'antd';
import { useGlobalContext } from '../../store/GlobalContext';
import Et706Editor from './et706';

const { Title } = Typography;

/** New York estate-tax return (ET-706) inputs. */
export default function EstateTaxPage() {
  const { selectedEstate } = useGlobalContext();
  const estateId = selectedEstate?.uuid || '';
  if (!estateId) return null;
  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Estate Tax (ET-706)</Title>
      <Et706Editor estateId={estateId} />
    </div>
  );
}
